export default "__VITE_ASSET__b3V3s5$n__"